import { render, staticRenderFns } from "./deliveryterm.vue?vue&type=template&id=3c2651fb&scoped=true&"
import script from "./deliveryterm.vue?vue&type=script&lang=js&"
export * from "./deliveryterm.vue?vue&type=script&lang=js&"
import style0 from "./deliveryterm.vue?vue&type=style&index=0&id=3c2651fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2651fb",
  null
  
)

export default component.exports